import type { IconDefaultProps } from './types'

const ChevronLeft = ({ className }: IconDefaultProps): JSX.Element => (
  <svg
    className={className}
    width='9'
    height='18'
    viewBox='0 0 9 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.51562 16.0313C8.79688 16.3125 8.79688 16.7813 8.46875 17.0625C8.1875 17.3438 7.71875 17.3438 7.4375 17.0156L0.6875 9.51563C0.40625 9.23438 0.40625 8.81251 0.6875 8.53126L7.4375 1.07813C7.71875 0.750007 8.1875 0.750007 8.46875 0.984382C8.79688 1.31251 8.79688 1.78126 8.51562 2.06251L2.23438 9.00001L8.51562 16.0313Z'
      fill='currentColor'
    />
  </svg>
)

export default ChevronLeft
